const { sanitizePaymentData } = require('../../util');
const { validateWsUrl } = require('../../security');
const { mainConfigService } = require('../config');
const BaseSocketService = require('./BaseSocketService');

const RECONNECT = { maxAttempts: 5, baseDelayMs: 1000, maxDelayMs: 30000 };

/**
 * Long-lived WebSocket client for live session/amount updates.
 * Applies pushed payloads to mainConfigService and notifies the view via
 * onRefresh. Reconnects with backoff on unexpected disconnects.
 */
class SessionSocketService {
  constructor({ onRefresh = null } = {}) {
    this.onRefresh = onRefresh;
    this.base = new BaseSocketService({
      oneShot: false,
      reconnect: RECONNECT,
      errorContext: 'session_socket_message',
      onMessage: (parsed) => this._handleMessage(parsed),
    });
  }

  connect({ wsUrl, sessionId, merchantId }) {
    if (!validateWsUrl(wsUrl)) return;
    if (!sessionId || !merchantId) return;
    this.base
      .connect({ wsUrl, referenceNumber: sessionId, merchantId })
      .catch(() => {}); // transport errors are reported inside the base
  }

  close() {
    this.base.close();
  }

  _handleMessage(parsed) {
    const payload = parsed?.sdk_setup_preload_payload || parsed;
    if (!payload || typeof payload.amount === 'undefined') return;

    const refreshed = sanitizePaymentData(payload);

    mainConfigService.updateConfig({
      amount: refreshed.amount,
      currency_code: refreshed.currency_code,
      billing: refreshed.billing,
      ...(refreshed.payment_methods?.length && { payment_methods: refreshed.payment_methods }),
      ...(refreshed.payment_services?.length && { payment_services: refreshed.payment_services }),
      ...(refreshed.cards?.length && { cards: refreshed.cards }),
      ...(refreshed.flex_methods?.length && { flex_methods: refreshed.flex_methods }),
    });

    if (this.onRefresh) this.onRefresh(refreshed);
  }
}

module.exports = SessionSocketService;
